export function searchServiceHost(host) {
    const hostname = host.replace(/:\d+$/, '').toLowerCase();
    if (hostname === 'gigastelle.de' || hostname === 'gigastelle.de.local') {
        return `search.${host}`;
    }

    return host.replace(/^www\./, 'search.');
}
